import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__left">
          <a href="#hero" className="footer__logo">
            <span className="footer__logo-bracket">&lt;</span>
            GM
            <span className="footer__logo-bracket"> /&gt;</span>
          </a>
        </div>
        <p className="footer__copy">
          {t('footer.copy')} &copy; {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
